<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.riskAssessment')"
    resource="risk_assessments"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/risk_assessments.js';
import { columnsExtend as RAQColumnsExtend, formColumnsExtend as RAQFormColumnsExtend } from '../admin_entities/risk_assessment_question_detail.js';
import { formColumnsExtend as RAOFormColumnsExtend } from '../admin_entities/risk_assessment_option_detail.js';
import _ from 'lodash';

@Component
export default class RiskAssessments extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [

    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'name',
      'kind',
      'state',
      type === 'show' && {
        key: 'risk_assessment_questions',
        renderCell: (h, { props: { value } }) => {
          return <bean-table
            style={{ width: '800px' }}
            value={value}
            columns={RAQColumnsExtend([
              'kind',
              'content',
              'position',
              {
                key: 'risk_assessment_options',
                renderCell: (h, { props: { value } }) => {
                  return _.map(value, (item) => {
                    return <div>
                      <span>{item.content}</span>
                      <span>({item.score})</span>
                    </div>
                  })
                }
              }
            ])}
          />;
        }
      },
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'name',
      'kind',
      {
        key: 'risk_assessment_questions',
        renderCell: {
          component: 'nestForm',
          props: {
            columns: RAQFormColumnsExtend([
              'kind',
              'content',
              'position',
              {
                key: 'risk_assessment_options',
                renderCell: {
                  component: 'nestForm',
                  props: {
                    columns: RAOFormColumnsExtend([
                      'content',
                      'score',
                      'position',
                    ], { data: {}, type }),
                  },
                },
              }
            ], { data: {}, type })
          }
        }
      }
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      row.state === 'draft' && {
        component: 'confirmButton',
        props: {
          label: '发布',
          type: 'primary',
          can: 'risk_assessments.update'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/risk_assessments/${row.id}/publish`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      row.state === 'draft' && {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'risk_assessments.edit', params: { id: row.id } }
        }
      },
      row.state === 'draft' && {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'risk_assessments.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('clone'),
          type: 'primary',
          can: 'risk_assessments.create'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.post(`/risk_assessments/${row.id}/clone`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/risk_assessments',
    name: 'risk_assessments.index',
    component: RiskAssessments,
    props: {
      type: 'index',
    }
  },
  {
    path: '/risk_assessments/new',
    name: 'risk_assessments.new',
    component: RiskAssessments,
    props: {
      type: 'new',
    }
  },
  {
    path: '/risk_assessments/:id',
    name: 'risk_assessments.show',
    component: RiskAssessments,
    props: {
      type: 'show',
    }
  },
  {
    path: '/risk_assessments/:id/edit',
    name: 'risk_assessments.edit',
    component: RiskAssessments,
    props: {
      type: 'edit'
    }
  }
]
</script>
